import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-masters-programs-in-computer-management',
  templateUrl: './top-masters-programs-in-computer-management.component.html',
  styleUrls: ['./top-masters-programs-in-computer-management.component.scss']
})
export class TopMastersProgramsInComputerManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
